// src/components/digital_twin/TwinLiveIndicator.js
// --- UPDATE (Digital Twin MOW+ v1) — NEW FILE -----------------------------------------------
// WebSocket health for the twin header: connected / reconnecting / offline, readings per minute
// and the age of the last message. `connected` null = the socket service does not say.
// --- END UPDATE ---------------------------------------------------------------------------
import React, { memo, useEffect, useState } from 'react';
import { Badge, Box, HStack, Text, Tooltip } from '@chakra-ui/react';

const ago = (ms) => { if (ms === null || ms === undefined) return '—'; const s = Math.max(0, Math.round((Date.now() - ms) / 1000)); return s < 5 ? 'now' : s < 60 ? `${s}s` : s < 3600 ? `${Math.floor(s / 60)}m` : `${Math.floor(s / 3600)}h`; };

const TwinLiveIndicator = memo(({ connected = null, isLive = true, lastMessageAt = null, perMinute = null }) => {
    const [, tick] = useState(0);
    useEffect(() => { const t = setInterval(() => tick((x) => x + 1), 5000); return () => clearInterval(t); }, []);
    const state = !isLive ? 'paused' : connected === false ? 'offline' : connected === true ? 'online' : 'unknown';
    const color = { online: 'green', offline: 'red', paused: 'purple', unknown: 'gray' }[state];
    const label = { online: 'Socket live', offline: 'Socket offline', paused: 'Replay', unknown: 'Socket' }[state];
    const tip = state === 'offline'
        ? 'The live feed is disconnected — the twin keeps the last readings and refreshes from the server every 2 minutes until it reconnects.'
        : state === 'paused' ? 'Historical replay — live messages are not applied.' : `Last message ${ago(lastMessageAt)} ago${perMinute !== null ? ` · ${perMinute} message(s) in the last minute` : ''}.`;
    return (
        <Tooltip label={tip} hasArrow>
            <HStack spacing={1.5} role="status" aria-label={`Live feed: ${label}`}>
                <Box w="8px" h="8px" borderRadius="full" bg={`${color}.400`} />
                <Badge colorScheme={color} variant="subtle" borderRadius="full" fontSize="2xs">{label}</Badge>
                {isLive && <Text fontSize="2xs" fontWeight="700" opacity={0.75}>{perMinute !== null ? `${perMinute}/min` : ''}{lastMessageAt ? ` · ${ago(lastMessageAt)}` : ''}</Text>}
            </HStack>
        </Tooltip>
    );
});
TwinLiveIndicator.displayName = 'TwinLiveIndicator';
export default TwinLiveIndicator;
